import { useState } from "react";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyBanner() {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified || user.role === "recruiter") return null;
  const resend = async () => {
    try { await api.post("/auth/resend-verification"); setSent(true); toast.success(`Verification email sent to ${user.email}`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mb-6 flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 sm:flex-row sm:items-center sm:justify-between" data-testid="verify-email-banner">
      <span className="flex items-center gap-2"><MailWarning className="h-4 w-4 shrink-0" />Please confirm {user.email}. {user.role === "recruiter" ? "Posting jobs and contacting candidates require a verified email." : "Confirming keeps your account secure and lets us send password resets."}</span>
      <Button size="sm" variant="outline" onClick={resend} disabled={sent} data-testid="verify-email-resend-button">{sent ? "Sent — check your inbox" : "Resend email"}</Button>
    </div>
  );
}
